"use client"

import { usePathname } from "next/navigation"
import { useEffect, useRef } from "react"
import { toast } from "sonner"

export const TToastLocationDismissal = (): null => {
	const pathname = usePathname()
	const previousPathname = useRef<string | null>(null)

	useEffect(() => {
		if (previousPathname.current !== null && previousPathname.current !== pathname) {
			toast.dismiss()
		}
		previousPathname.current = pathname
	}, [pathname])

	return null
}
